export const categories = [
  {
    id: 'entertainment',
    name: '娱乐八卦',
    slug: 'entertainment',
    description: '明星绯闻、娱乐圈内幕、名人动态一手掌握',
    icon: 'ri-star-line',
    articleCount: 1286,
    color: 'primary',
  },
  {
    id: 'social',
    name: '社会热点',
    slug: 'social',
    description: '社会新闻、民生话题、舆论焦点实时追踪',
    icon: 'ri-fire-line',
    articleCount: 956,
    color: 'accent',
  },
  {
    id: 'celebrity',
    name: '明星黑料',
    slug: 'celebrity',
    description: '独家爆料、明星隐私、幕后真相深度揭秘',
    icon: 'ri-user-search-line',
    articleCount: 742,
    color: 'secondary',
  },
  {
    id: 'internet',
    name: '网红资讯',
    slug: 'internet',
    description: '网红动态、直播圈事、短视频热点全收录',
    icon: 'ri-video-line',
    articleCount: 623,
    color: 'primary',
  },
  {
    id: 'scandal',
    name: '丑闻曝光',
    slug: 'scandal',
    description: '重大丑闻、负面事件、真相调查独家报道',
    icon: 'ri-flashlight-line',
    articleCount: 534,
    color: 'accent',
  },
  {
    id: 'exclusive',
    name: '独家爆料',
    slug: 'exclusive',
    description: '内部消息、知情人士透露、第一手资讯',
    icon: 'ri-eye-line',
    articleCount: 389,
    color: 'secondary',
  },
];